<template>
  <div class="auth-cabinet">
    <header>
      <template v-if="groupTemplate">
        <component :is="`header-information-navigation-${sid}`" />
      </template>
      <information-navigation v-else />
    </header>
    <main>
      <b-container fluid class="pt-0 pb-5 p-0" id="content">
        <b-container>
          <b-row>
            <b-col cols="12">
              <router-view />
            </b-col>
          </b-row>
        </b-container>
      </b-container>
    </main>
    <template>
      <template v-if="groupTemplate">
        <component :is="`footer-component-${sid}`" />
      </template>
      <footer-component v-else />
    </template>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import InformationNavigation from '@/components/Header/InformationNavigation.vue';
import HeaderInformationNavigationJig from '@/components/Themes/HeaderInformationNavigationJig.vue';
import HeaderInformationNavigationTalentpool from '@/components/Themes/HeaderInformationNavigationTalentpool.vue';
import HeaderInformationNavigationRagtp from '@/components/Themes/HeaderInformationNavigationRagtp.vue';
import HeaderInformationNavigationT4a from '@/components/Themes/HeaderInformationNavigationT4a.vue';
import HeaderInformationNavigationNcph from '@/components/Themes/HeaderInformationNavigationNcph.vue';
import HeaderInformationNavigationWconat from '@/components/Themes/HeaderInformationNavigationWconat.vue';
import HeaderInformationNavigationKh from '@/components/Themes/HeaderInformationNavigationKh.vue';
import HeaderInformationNavigationRhh from '@/components/Themes/HeaderInformationNavigationRhh.vue';
import HeaderInformationNavigationHe from '@/components/Themes/HeaderInformationNavigationHe.vue';
import HeaderInformationNavigationKle from '@/components/Themes/HeaderInformationNavigationKle.vue';
import HeaderInformationNavigationWrktp from '@/components/Themes/HeaderInformationNavigationWrktp.vue';
import PagesNavigation from '@/components/Header/PagesNavigation.vue';
import FooterComponent from '@/components/FooterComponent.vue';
import FooterComponentJig from '@/components/Themes/FooterComponentJig.vue';
import FooterComponentTalentpool from '@/components/Themes/FooterComponentTalentpool.vue';
import HeaderInformationNavigationEdunet from '@/components/Themes/HeaderInformationNavigationEdunet.vue';
import HeaderInformationNavigationEdunetke from '@/components/Themes/HeaderInformationNavigationEdunetke.vue';
import HeaderInformationNavigationEdunetasia from '@/components/Themes/HeaderInformationNavigationEdunetasia.vue';
import HeaderInformationNavigationEdunetma from '@/components/Themes/HeaderInformationNavigationEdunetma.vue';
import { AppModule } from '@/store/modules/app';
import { UserModule } from '@/store/modules/user';
import FooterComponentT4a from '@/components/Themes/FooterComponentT4a.vue';
import FooterComponentNcph from '@/components/Themes/FooterComponentNcph.vue';
import FooterComponentWconat from '@/components/Themes/FooterComponentWconat.vue';
import FooterComponentEdunet from '@/components/Themes/FooterComponentEdunet.vue';
import FooterComponentEdunetke from '@/components/Themes/FooterComponentEdunetke.vue';
import FooterComponentEdunetasia from '@/components/Themes/FooterComponentEdunetasia.vue';
import FooterComponentEdunetma from '@/components/Themes/FooterComponentEdunetma.vue';
import FooterComponentKh from '@/components/Themes/FooterComponentKh.vue';
import FooterComponentRhh from '@/components/Themes/FooterComponentRhh.vue';
import FooterComponentHe from '@/components/Themes/FooterComponentHe.vue';
import FooterComponentRagtp from '@/components/Themes/FooterComponentRagtp.vue';
import FooterComponentKle from '@/components/Themes/FooterComponentKle.vue';
import FooterComponentWrktp from '@/components/Themes/FooterComponentWrktp.vue';
import { group } from '@/config/configuration';
import HeaderInformationNavigationJobtalent from '@/components/Themes/HeaderInformationNavigationJobtalent.vue';
import FooterComponentJobtalent from '@/components/Themes/FooterComponentJobtalent.vue';
import HeaderInformationNavigationJnjts from '@/components/Themes/HeaderInformationNavigationJnjts.vue';
import FooterComponentJnjts from '@/components/Themes/FooterComponentJnjts.vue';
import HeaderInformationNavigationAmseu
  from '@/components/Themes/HeaderInformationNavigationAmseu.vue';
import FooterComponentAmseu from '@/components/Themes/FooterComponentAmseu.vue';
import HeaderInformationNavigationCoe from '@/components/Themes/HeaderInformationNavigationCoe.vue';
import FooterComponentCoe from '@/components/Themes/FooterComponentCoe.vue';
import HeaderInformationNavigationBbg from '@/components/Themes/HeaderInformationNavigationBbg.vue';
import FooterComponentBbg from '@/components/Themes/FooterComponentBbg.vue';

@Component({
  components: {
    HeaderInformationNavigationJnjts,
    HeaderInformationNavigationKle,
    HeaderInformationNavigationBbg,
    HeaderInformationNavigationRagtp,
    FooterComponentWrktp,
    FooterComponentJnjts,
    InformationNavigation,
    PagesNavigation,
    FooterComponent,
    HeaderInformationNavigationJig,
    HeaderInformationNavigationTalentpool,
    HeaderInformationNavigationJobtalent,
    HeaderInformationNavigationEdunet,
    HeaderInformationNavigationEdunetke,
    HeaderInformationNavigationEdunetasia,
    HeaderInformationNavigationEdunetma,
    HeaderInformationNavigationT4a,
    HeaderInformationNavigationNcph,
    HeaderInformationNavigationWconat,
    HeaderInformationNavigationKh,
    HeaderInformationNavigationRhh,
    HeaderInformationNavigationHe,
    FooterComponentJig,
    FooterComponentTalentpool,
    FooterComponentJobtalent,
    FooterComponentEdunet,
    FooterComponentT4a,
    FooterComponentNcph,
    FooterComponentWconat,
    FooterComponentEdunetke,
    FooterComponentEdunetasia,
    FooterComponentEdunetma,
    FooterComponentKh,
    FooterComponentRhh,
    FooterComponentHe,
    FooterComponentRagtp,
    FooterComponentKle,
    FooterComponentBbg,
    HeaderInformationNavigationWrktp,
    HeaderInformationNavigationAmseu,
    FooterComponentAmseu,
    HeaderInformationNavigationCoe,
    FooterComponentCoe,
  },
})
export default class CabinetTemplate extends Vue {
  get sid() {
    return AppModule.sid;
  }

  get languageSid() {
    return AppModule.languageSid;
  }

  get accessTokenApplicant() {
    return UserModule.accessTokenApplicant;
  }

  get accessTokenConsultant() {
    return UserModule.accessTokenConsultant;
  }

  get accessTokenCompany() {
    return UserModule.accessTokenCompany;
  }

  get groupTemplate() {
    return group(this.sid);
  }
}
</script>
